
import { mapState } from 'vuex';
import Gallery from './components/Gallery';

export default {
  i18nComponentKey: 'WidgetReviewsGallery.WidgetReviewsGalleryPc',
  name: 'WidgetReviewsGalleryPc',
  components: { Gallery },
  computed: {
    ...mapState('widget', ['widget']),
    galleryProps() {
      const { layout_column, column_gap, row_gap } = this.widget;
      return {
        cols: layout_column,
        gutter: column_gap,
        productImageSize: 48,
        rowGap: row_gap
      };
    }
  }
};
